export interface IAnimationConfig {
  timeouts: {
    backdrop: number
    cartPulse: number
    cartSlideIn: number
  }
}

export const animation: IAnimationConfig = {
  timeouts: {
    backdrop: 300,
    cartPulse: 1500,
    cartSlideIn: 300
  }
}
